/**
 * Describes the shape of a single action.
 */
export interface IPackageListingStateAction {
    type: ActionType;
    value?: any;
}

/**
 * Represents all of the actions that a user can perform on the package listing page. It's a class so that a dev can extend it.
 */
export class ActionType {
    
    static get UpdatePerformancesFilter() {
        return "UpdatePerformancesFilter";
    }
    
    static get RemovePerformancesFilter() {
        return "RemovePerformancesFilter";
    }
    static get RemoveAllPerformancesFilters() {
        return "RemoveAllPerformancesFilters";
    }

    static get PerformancesUpdated() {
        return "PerformancesUpdated";
    }
    
    static get BrowserNavigated() {
        return "BrowserNavigated";
    }
    
    static get LoadPackage() {
        return "LoadPackage";
    }

    static get LoadPackageRequest() {
        return "LoadPackageRequest";
    }

    static get LoadPackages() {
        return "LoadPackages";
    }

    static get UpdateSettings() {
        return "UpdateSettings";
    }

    static get SelectPerformance() {
        return "SelectPerformance";
    }

    static get AddItemToCart() {
        return "AddItemToCart";
    }

    static get RemoveItemFromCart() {
        return "RemoveItemFromCart";
    }
    
    static get UpdatePriceTypeQuantity() {
        return "UpdatePriceTypeQuantity";
    }

    static get GetUnseatedFlexPricingFromPt() {
        return "GetUnseatedFlexPricingFromPt";
    }

    static get ClearPriceTypeQuantities() {
        return "ClearPriceTypeQuantities";
    }

    static get UpdateSelectedZone() {
        return "UpdateSelectedZone";
    }

    static get RemoveSelectedZone() {
        return "RemoveSelectedZone";
    }

    static get UpdateOrderNotes() {
        return "UpdateOrderNotes";
    }

    static get UpdateSeatingPreferences() {
        return "UpdateSeatingPreferences";
    }

    static get UpdatePackageProcessing() {
        return "UpdatePackageProcessing";
    }

    static get UpdatePackageProcessingErrors() {
        return "UpdatePackageProcessingErrors";
    }

    static get RequestPerformancePricing() {
        return "RequestPerformancePricing";
    }

    static get ReceivePerformancePricing() {
        return "ReceivePerformancePricing";
    }

    static get ReceivePackagePricing() {
        return "ReceivePackagePricing";
    }

    static get ToggleMiniCart() {
        return "ToggleMiniCart";
    }

    static get SetSpecialFeatureMap() {
        return "SetSpecialFeatureMap";
    }

    static get ToggleAlternateRequestType() {
        return "ToggleAlternateRequestType";
    }

    static get SelectAlternateFixedPackage() {
        return "SelectAlternateFixedPackage";
    }

    static get DisablePerformanceButtons() {
        return "DisablePerformanceButtons";
    }

 //static get RequestText() {
    //    return "RequestText";
    //}
    //static get ReceiveText() {
    //    return "ReceiveText";
    //}
}